import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';

import { onValueChange, paymentClear } from '../reducer';

import { CurrenciesEnum } from '../../../constants/currencies';
import { donationPaymentType } from '../../../constants/donationTypeOptions';

class DonatePaymentTypeSelectView extends React.Component {
    handleChange = value => {
        this.props.onValueChange('paymentType', value);
        this.props.paymentClear();
    }

    render() {
        let donationPaymentTypeOptions = [];
        donationPaymentTypeOptions.push(donationPaymentType.creditCard);

        if (this.props.allowBankAccountPayment && this.props.currency === CurrenciesEnum.AUD) {
            donationPaymentTypeOptions.push(donationPaymentType.bankAccount);
        }

        if (this.props.allowPledgePayment && !this.props.isRecurring) {
            donationPaymentTypeOptions.push(donationPaymentType.pledge);
        }

        return (
            <React.Fragment>
                {
                    donationPaymentTypeOptions.length > 1 &&
                    <div className="donation-type-pager">
                        {
                            React.Children.toArray(
                                donationPaymentTypeOptions.map(option => {
                                    const isActive = option.value === this.props.value;
                                    return (
                                        <div
                                            className={`donation-type-option ${isActive ? "active" : ""}`}
                                            onClick={this.handleChange.bind(this, option.value)}
                                        >
                                            {option.label}
                                        </div>
                                    );
                                })
                            )
                        }
                    </div>
                }

            </React.Fragment>
        );
    }
}
const mapState = state => {
    return {
        value: get(state.donation, 'paymentType'),
        allowBankAccountPayment: !get(state, 'page.campaign.template.value.donationSetup.disableBankAccountPayment'),
        allowPledgePayment: get(state, 'page.campaign.template.value.donationSetup.allowPledgePayment'),
        isRecurring: get(state, 'donation.subscription.enabled'),
        currency: get(state, 'page.organization.currency')
    };
};

const mapDispatch = dispatch => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value));
        },
        paymentClear() {
            dispatch(paymentClear());
        }
    };
};

const DonatePaymentTypeSelect = connect(mapState, mapDispatch)(DonatePaymentTypeSelectView);
export default DonatePaymentTypeSelect;